import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface CountDTO {
  count: number;
}

export class Count {
  readonly isCountCount: boolean = true;

  readonly count: number;

  static readonly constraints = {
    "count": {
      "minValue": 0,
    }
  }

  constructor(
  count: number
  ) {
    Count.validateCount(count);
    this.count = count;
  }

  static fromDTO(dto: CountDTO): Count {
    const count = getInt32(dto, "count", InvalidCountCountError);
    return new Count(
      count
    );
  }

  toDTO(): CountDTO {
    const dto: CountDTO = {
        count: this.count
    };
    return dto;
  }
  private static validateCount = (count: number): void => {
    if(count < 0) {
      throw new InvalidCountCountMinValueError(
        0,
        `Attribute count has value ${count}. Min value is 0.`
      );
    }
  }
  
}

Count.prototype.toString = function toString(): string {
  return `Count(count='${this.count}')`;
};

export class InvalidCountError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCountError";
  }
}
export class InvalidCountCountError extends InvalidCountError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCountCountError";
  }
}

export class InvalidCountCountMinValueError extends InvalidCountCountError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidCountCountMinValueError";
  }
}
